import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { StatusPillComponent } from '@shared/components/general/status-pill/status-pill.component';
import { StatusPillColorsEnum } from '@shared/enums';
import { TooltipModule } from 'primeng/tooltip';
import { ReactionResultStatusEnum } from 'src/app/features/orders/_shared/_enums';
import { reactionResultStatusNames, reactionResultStatusTooltips } from 'src/app/features/orders/_shared/consts';

@Component({
    selector: 'app-order-results-reaction-status',
    standalone: true,
    imports: [TranslateModule, TooltipModule, StatusPillComponent],
    templateUrl: './order-results-reaction-status.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderResultsReactionStatusComponent {
    readonly status = input.required<ReactionResultStatusEnum>();
    readonly size = input<'large' | 'small'>('small');
    readonly actionRequiredInfoTooltip = input<string | null>(null);

    readonly statusTooltip = computed(() => reactionResultStatusTooltips[this.status()]);
    readonly statusName = computed(() => reactionResultStatusNames[this.status()]);
    readonly statusColor = computed(() => {
        switch (this.status()) {
            case ReactionResultStatusEnum.ACTION_REQUIRED:
                return StatusPillColorsEnum.RED;
            case ReactionResultStatusEnum.COMPLETED:
                return StatusPillColorsEnum.GREEN;
            case ReactionResultStatusEnum.IN_PROGRESS:
                return StatusPillColorsEnum.BLUE;
            case ReactionResultStatusEnum.RECEIVED:
                return StatusPillColorsEnum.PURPLE;
            case ReactionResultStatusEnum.SUBMITTED:
                return StatusPillColorsEnum.ORANGE;
            case ReactionResultStatusEnum.CANCELED:
                return StatusPillColorsEnum.DARK_GRAY;
            case ReactionResultStatusEnum.CANCELED_FROM_LIMS:
                return StatusPillColorsEnum.DARK_GRAY;
            default:
                return StatusPillColorsEnum.LIGHT_GRAY;
        }
    });
    readonly reactionResultStatuses = ReactionResultStatusEnum;
}
